import {get} from '../utils'

export default host => query =>
  get(`${host}/trials?include=user&q=${query}`)
    .then(response => response.json())
    .then(json => json.data)
